import React, { Component } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { CircleHelp } from "lucide-react";
import { connect } from "react-redux";
import { Tooltip } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import AcertosPorHabilidade from "../../../components/Statistics/AcertosPorHabilidade";
import AcertosPorObjetivo from "../../../components/Statistics/AcertosPorObjetivo";
import AcertosPorQuestao from "../../../components/Statistics/AcertosPorQuestao";
import AcertosPorUnidadeTematica from "../../../components/Statistics/AcertosPorUnidadeTematica";
import AssuntoAvaliacao from "../../../components/Statistics/Comparison/AssuntoAvaliacao";
import DataQFiltro from "../../../components/Statistics/Comparison/DataQuestionsFiltro";
import ComparacaoEscola from "../../../components/Statistics/Comparison/Escolas";
import HistogramaAluno from "../../../components/Statistics/Comparison/HistogramaAluno";
import HistogramaEscola from "../../../components/Statistics/Comparison/HistogramaEscola";
import HistogramaTurma from "../../../components/Statistics/Comparison/HistogramaTurma";
import ListaNotasFiltro from "../../../components/Statistics/Comparison/ListaNotasFiltro";
import ComparacaoRegional from "../../../components/Statistics/Comparison/Regionais";
import ComparacaoTurma from "../../../components/Statistics/Comparison/Turmas";
import { DataProvider } from "../../../components/Statistics/Context/DataContext";
import { log } from "../../../utils/log";

import "./style.css";

class EvaluationStatistics extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      menu: 1,
      printDiv: React.createRef(),
      expandedMenu: null,
      tooltipOpen: false
    };
  }

  async componentDidMount() {
    () => this.createLog();
  }

  toggle() {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas da lista ${this.props.title}${
        this.props.activity_id
          ? ` dentro da atividade com id ${this.props.activity_id}`
          : ""
      }`,
      this.props.activity_id,
      this.props.user.token,
      this.props.activity_id || null,
      this.props.general.active_roles.school_id || null
    );
  }

  isConstruir() {
    return (
      this.props.profile.user_role.some(item => item.group_id === 80) &&
      this.props.user.user_roles[0].role_id !== 2
    );
  }

  getMenus() {
    const isConstruir = this.isConstruir();

    return [
      {
        id: 5,
        name: (
          <div className="d-flex align-items-center">
            Habilidade
            <span className="badge badge-danger ml-1">Novo</span>
          </div>
        ),
        title: "Percentual por Habilidade",
        tutorial: (
          <>
            <p>
              Na Tela de Habilidades, você tem uma visão clara do desempenho da
              turma em relação às habilidades avaliadas em cada questão da prova
              selecionada.
            </p>
            <p>
              Para cada habilidade, você verá a quantidade de acertos dos
              estudantes, além do percentual total de acertos da turma,
              permitindo identificar de forma rápida quais competências estão
              sendo dominadas e quais ainda precisam de reforço.
            </p>
            <p>
              Caso perceba que uma habilidade específica precisa ser trabalhada
              mais a fundo, você pode facilmente aplicar uma atividade
              personalizada que está listada abaixo de cada habilidade, com
              apenas um clique.
            </p>
            <p>
              Essa funcionalidade oferece atividades prontas relacionadas à
              habilidade, facilitando sua intervenção pedagógica e garantindo
              que os estudantes recebam o suporte necessário no momento certo.
            </p>
          </>
        ),
        icon: "fa fa-pencil",
        component: <AcertosPorHabilidade activity_id={this.props.activity_id} />
      },
      {
        id: 1,
        name: "Lista de Notas",
        title: "Lista de Notas",
        tutorial: (
          <>
            <p>
              Na Tela de Listagem de Notas, você encontrará todos os estudante
              da turma selecionada com suas notas individuais na prova,
              oferecendo uma visão detalhada do desempenho de cada um.
            </p>
            <p>
              Além de visualizar as notas, você também pode acessar a prova
              realizada pelo estudantes, verificando cada questão e as
              alternativas que ele marcou, o que facilita na análise de erros
              comuns e padrões de resposta.
            </p>
            <p>
              Para ajudar ainda mais na compreensão do desempenho, a tela
              apresenta um gráfico comparativo que destaca a nota do estudante
              em relação à média da turma, da escola, da regional e até do grupo
              ao qual ele pertence.
            </p>
            <p>
              Isso permite que você identifique rapidamente se o estudante está
              abaixo, na média ou acima desses níveis de referência, oferecendo
              dados valiosos para direcionar intervenções pedagógicas mais
              precisas.
            </p>
          </>
        ),
        icon: "fa fa-graduation-cap",
        component: <ListaNotasFiltro activity_id={this.props.activity_id} />
      },
      {
        id: 2,
        name: "Descritor e Distrator",
        title: "Descritor e Distrator",
        tutorial: (
          <>
            <p>
              A Tela de Descritor e Distrator oferece uma análise detalhada das
              alternativas de cada questão da prova. Para cada questão, você
              verá a porcentagem de estudantes que escolheram cada uma das
              alternativas, facilitando a identificação de padrões de erro e
              compreensão.
            </p>
            <p>
              A alternativa correta é destacada em azul, permitindo que você
              veja rapidamente quantos estudantes acertaram. Já a alternativa
              errada mais escolhida, conhecida como distrator, está destacada em
              amarelo, ajudando a identificar os principais equívocos dos
              estudantes.
            </p>
            <p>
              Essa visão permite que você entenda melhor onde eles estão tendo
              dificuldades e, com isso, planeje estratégias pedagógicas mais
              eficazes para corrigir esses erros.
            </p>
          </>
        ),
        icon: "fa fa-list",
        component: <DataQFiltro activity_id={this.props.activity_id} />
      },
      {
        id: 3,
        name: "Percentual",
        icon: "fa fa-percent",
        component: null,
        subMenu: [
          {
            id: 4,
            name: "Questão",
            title: "Percentual por Questão",
            tutorial: (
              <>
                <p>
                  Na Tela de Porcentagem por Questão, você tem acesso à lista
                  completa de questões aplicadas na prova e uma análise
                  detalhada do desempenho da turma em cada uma delas.
                </p>
                <p>
                  Para cada questão, é apresentada a quantidade de acertos e o
                  percentual de estudantes que responderam corretamente,
                  oferecendo uma visão clara sobre quais questões foram mais
                  fáceis e quais representaram maior dificuldade para os
                  estudantes.
                </p>
                <p>
                  Com essas informações, você pode identificar de forma rápida
                  as áreas onde a turma está indo bem e as que podem precisar de
                  mais atenção em sala de aula, facilitando ajustes no
                  planejamento de aulas futuras.
                </p>
              </>
            ),
            component: (
              <AcertosPorQuestao activity_id={this.props.activity_id} />
            )
          },
          {
            id: 6,
            name: "Objetivo",
            title: "Percentual por Objetivo",
            tutorial: (
              <>
                <p>
                  Na Tela de Percentual por Objetivo, você tem acesso ao
                  desempenho da turma em relação aos objetivos pedagógicos
                  associados a cada questão da prova.
                </p>
                <p>
                  Cada questão é categorizada dentro de um objetivo específico,
                  e a tela apresenta o percentual de acertos por objetivo,
                  permitindo uma análise detalhada sobre como os estudantes
                  estão compreendendo competências e habilidades mais amplas.
                </p>
                <p>
                  Com essas informações, você pode ajustar o planejamento
                  pedagógico para focar nos objetivos em que a turma apresenta
                  maior dificuldade, otimizando as intervenções em sala de aula.
                </p>
              </>
            ),
            component: (
              <AcertosPorObjetivo activity_id={this.props.activity_id} />
            )
          },
          {
            id: 7,
            name: "Unidade Temática",
            title: "Percentual por Unidade Temática",
            tutorial: (
              <>
                <p>
                  A Tela de Percentual por Unidade Temática permite que você
                  visualize o desempenho da turma em conjuntos maiores de
                  objetivos, agrupados em unidades temáticas.
                </p>
                <p>
                  A tela apresenta o percentual de acertos para cada unidade
                  temática, oferecendo uma visão abrangente sobre a compreensão
                  dos conteúdos.
                </p>
                <p>
                  Com essas informações, é possível ajustar o planejamento
                  pedagógico de forma eficaz, focando nas áreas que precisam de
                  mais atenção, com uma visão estratégica do progresso da turma.
                </p>
              </>
            ),
            component: (
              <AcertosPorUnidadeTematica activity_id={this.props.activity_id} />
            )
          }
        ]
      },
      !isConstruir && {
        id: 8,
        name: "Comparação",
        icon: "fa fa-anchor",
        component: null,
        subMenu: [
          {
            id: 9,
            name: "Turmas",
            title: "Comparação entre turmas",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação entre Turmas permite que você compare o
                  desempenho de diferentes turmas que realizaram a mesma prova.
                </p>
                <p>
                  Nesta tela, você verá a nota média de cada turma,
                  identificando variações de desempenho entre elas.
                </p>
                <p>
                  Essa comparação facilita a análise de padrões de aprendizagem
                  e permite o ajuste de estratégias pedagógicas para cada grupo
                  de estudantes.
                </p>
              </>
            ),
            component: <ComparacaoTurma activity_id={this.props.activity_id} />
          },
          !isConstruir && {
            id: 10,
            name: "Escolas",
            title: "Comparação entre escolas",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação entre Escolas apresenta o desempenho
                  comparado das escolas da mesma regional que aplicaram a prova.
                </p>
                <p>
                  A nota média de cada escola é exibida, facilitando a
                  identificação de variações de desempenho.
                </p>
                <p>
                  Com esses dados, você pode ajustar práticas pedagógicas em
                  toda a regional e compartilhar estratégias entre escolas para
                  melhorias.
                </p>
              </>
            ),
            component: <ComparacaoEscola activity_id={this.props.activity_id} />
          },
          {
            id: 11,
            name: "Regionais",
            title: "Comparação entre regionais",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação entre Regionais permite a comparação do
                  desempenho médio de todas as regionais que fazem parte do
                  mesmo grupo.
                </p>
                <p>
                  A tela exibe a nota média de cada regional, proporcionando uma
                  visão ampla do desempenho geográfico.
                </p>
                <p>
                  Com essas informações, é possível compartilhar práticas
                  pedagógicas bem-sucedidas e focar em intervenções nas áreas
                  que necessitam de mais atenção.
                </p>
              </>
            ),
            component: (
              <ComparacaoRegional
                activity_id={this.props.activity_id}
                school_id={this.props.general.active_roles.school_id}
                {...this.props.general.active_roles}
              />
            )
          }
        ].filter(Boolean)
      },
      !isConstruir && {
        id: 13,
        name: "Habilidades",
        icon: "fa fa-heartbeat",
        component: null,
        subMenu: [
          {
            id: 14,
            name: "Estudante",
            title: "Estudantes vs Habilidade",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação Estudante vs Habilidade oferece uma
                  análise detalhada do desempenho de um estudante em relação às
                  habilidades avaliadas na prova.
                </p>
                <p>
                  O percentual de acertos do estudante é comparado com os da
                  turma, escola, regional e grupo.
                </p>
                <p>
                  Essa análise permite intervenções pedagógicas personalizadas,
                  identificando habilidades nas quais o estudante precisa de
                  mais apoio ou se destaca.
                </p>
              </>
            ),
            component: (
              <AssuntoAvaliacao
                activity_id={this.props.activity_id}
                key="alunoassunto"
              />
            )
          },
          {
            id: 15,
            name: "Turma",
            title: "Turma vs Habilidade",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação Turma vs Habilidade exibe o desempenho da
                  turma em relação às habilidades avaliadas na prova.
                </p>
                <p>
                  O percentual de acertos da turma é comparado com os da escola,
                  regional e grupo, ajudando a identificar habilidades que
                  precisam ser mais trabalhadas.
                </p>
                <p>
                  Com esses dados, você pode planejar intervenções pedagógicas
                  mais focadas, atendendo às necessidades da turma de forma
                  eficaz.
                </p>
              </>
            ),
            component: (
              <AssuntoAvaliacao
                activity_id={this.props.activity_id}
                hideUser
                key="turmaassunto"
              />
            )
          },
          {
            id: 16,
            name: "Escola",
            title: "Escola vs Habilidade",
            tutorial: (
              <>
                <p>
                  A Tela de Comparação Escola vs Habilidade apresenta o
                  desempenho da escola em relação às habilidades avaliadas na
                  prova.
                </p>
                <p>
                  O percentual de acertos da escola é comparado com os da
                  regional e do grupo, permitindo a identificação de habilidades
                  que precisam de maior atenção.
                </p>
                <p>
                  Com esses dados, você pode direcionar ações pedagógicas para
                  aprimorar o desenvolvimento das habilidades em nível escolar.
                </p>
              </>
            ),
            component: (
              <AssuntoAvaliacao
                activity_id={this.props.activity_id}
                hideUser
                hideRoom
                key="escolaassunto"
              />
            )
          }
        ]
      },
      !isConstruir && {
        id: 17,
        name: "Histograma",
        icon: "fa fa-bar-chart",
        component: null,
        subMenu: [
          {
            id: 18,
            name: "Estudantes",
            title: "Histograma dos estudantes",
            tutorial: (
              <>
                <p>
                  A Tela de Histograma por Estudantes oferece uma representação
                  visual clara do desempenho dos estudantes, com cada barra
                  representando um intervalo de notas.
                </p>
                <p>
                  O estudantes selecionado é destacado em vermelho, facilitando
                  a comparação da sua nota com as dos colegas.
                </p>
                <p>
                  Essa visão ajuda a avaliar rapidamente o posicionamento do
                  estudantes dentro da distribuição geral de notas da turma,
                  escola, regional ou grupo.
                </p>
              </>
            ),
            component: <HistogramaAluno activity_id={this.props.activity_id} />
          },
          {
            id: 19,
            name: "Turmas",
            title: "Histograma das turmas",
            tutorial: (
              <>
                <p>
                  A Tela de Histograma por Turma exibe uma visualização gráfica
                  das notas médias obtidas pelas turmas de uma escola.
                </p>
                <p>
                  A turma selecionada é destacada em vermelho, permitindo a
                  comparação da sua média com as demais turmas.
                </p>
                <p>
                  Essa análise facilita a identificação de padrões de desempenho
                  dentro da escola, ajudando a ajustar intervenções pedagógicas.
                </p>
              </>
            ),
            component: <HistogramaTurma activity_id={this.props.activity_id} />
          },
          {
            id: 20,
            name: "Escolas",
            title: "Histograma das escolas",
            tutorial: (
              <>
                <p>
                  A Tela de Histograma por Escolas apresenta uma visualização
                  gráfica das notas médias obtidas pelas escolas de uma mesma
                  regional.
                </p>
                <p>
                  A escola selecionada é destacada em vermelho, facilitando a
                  comparação do seu desempenho com as demais escolas da
                  regional.
                </p>
                <p>
                  Com esses dados, você pode identificar tendências de
                  desempenho e promover discussões sobre boas práticas entre as
                  escolas.
                </p>
              </>
            ),
            component: <HistogramaEscola activity_id={this.props.activity_id} />
          }
        ]
      }
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-0 mw-100"
        style={{ width: "100%", height: "100%", borderRadius: "0" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            <strong>Estatísticas</strong>
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              width: "20%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRight: "1px solid #d8dbe0",
              borderRadius: "0"
            }}
          >
            {this.getMenus()
              .filter(menu => !menu.hideMenu)
              .map(menu => (
                <React.Fragment key={menu.id}>
                  <CListGroupItem
                    action
                    className="user-select-none border-0 d-flex align-items-center justify-content-between cursor"
                    style={{
                      borderRadius: "10px",
                      margin: "10px",
                      width: "90%",
                      backgroundColor:
                        menu.id === this.state.menu ||
                        this.state.expandedMenu === menu.id
                          ? "#e3ebff"
                          : "transparent"
                    }}
                    onClick={() =>
                      this.setState(prevState => ({
                        menu: menu.component ? menu.id : prevState.menu,
                        expandedMenu:
                          prevState.expandedMenu === menu.id ? null : menu.id
                      }))
                    }
                  >
                    <div className="d-flex align-items-center">
                      <i
                        className={`mr-2 ${menu.icon}`}
                        style={{ width: "16px" }}
                      ></i>
                      {menu.name}
                    </div>
                    <i
                      className="ml-4 fa fa-chevron-right"
                      style={{
                        fontSize: "10px",
                        transform:
                          this.state.expandedMenu === menu.id
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        transition: "0.3s"
                      }}
                      hidden={!menu.subMenu}
                    ></i>
                  </CListGroupItem>
                  {menu.subMenu &&
                    this.state.expandedMenu === menu.id &&
                    menu.subMenu.map(subMenu => (
                      <CListGroupItem
                        action
                        className="user-select-none border-0 cursor"
                        style={{
                          borderRadius: "10px",
                          width: "90%",
                          color: subMenu.id === this.state.menu && "#284893"
                        }}
                        onClick={() => this.setState({ menu: subMenu.id })}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                          {subMenu.name}
                        </span>
                      </CListGroupItem>
                    ))}
                </React.Fragment>
              ))}
          </CListGroup>

          <div
            ref={this.state.printDiv}
            className="charts flex-1 d-flex justify-content-center px-4 py-3"
            style={{ overflow: "auto", backgroundColor: "#f9f9f9" }}
          >
            <div className="w-100">
              <div className="d-flex flex-column">
                {this.props.title && `${this.props.title}`}
                <div className="d-flex w-100 align-items-center mb-4">
                  <h4 className="mr-2 mb-0">
                    {
                      this.getMenus()
                        .flatMap(menu => [menu, ...(menu.subMenu || [])])
                        .find(item => item.id === this.state.menu)?.title
                    }
                  </h4>
                  <CircleHelp size={20} id="tour" className="cursor" />
                  <Tooltip
                    placement="bottom"
                    isOpen={this.state.tooltipOpen}
                    target="tour"
                    toggle={this.toggle}
                  >
                    {
                      this.getMenus()
                        .flatMap(menu => [menu, ...(menu.subMenu || [])])
                        .find(item => item.id === this.state.menu)?.tutorial
                    }
                  </Tooltip>
                </div>
                <DataProvider>
                  {(() => {
                    const allMenus = this.getMenus().flatMap(menu => [
                      menu,
                      ...(menu.subMenu || [])
                    ]);
                    const selectedMenu = allMenus.find(
                      menu => menu.id === this.state.menu
                    );
                    return selectedMenu && selectedMenu.component;
                  })()}
                </DataProvider>
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationStatistics);
